import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { APIResponse } from "./CommonApiSlice";
import { CodeResultResponse } from "@src/pages/challenge-exam/challenge-submission-result/challengeSubmissionResultTypes";
import { RunUserCodeRequest, RunUserCodeResponse } from "./RunApiSlice";
import { QuizRunPayload } from "@src/pages/challenge-exam/data.types";

const BASE_URL: string = import.meta.env.VITE_TEST_FRESHERS_CHALLENGE_BASE_URL;

export interface GetAllChallengeCategoryApiResponse extends APIResponse {
  response: {
    challengesCount: number;
    description: string;
    icon: string;
    id: string;
    name: string;
    questionTypes: string[];
  }[];
}

export const CategoryApiSlice = createApi({
  reducerPath: "categoryApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  tagTypes: ["getCategory"],
  endpoints: (builder) => ({
    getCategory: builder.query<GetAllChallengeCategoryApiResponse, void>({
      query: () => ({
        url: `challenge-category/get-all`,
        method: "GET",
      }),
      providesTags: ["getCategory"],
    }),
    addCategory: builder.mutation<
      { httpStatus: string; statusCode: number },
      {
        name: string;
        description: string;
        questionTypes: string[];
      }
    >({
      query: (payload) => ({
        url: `challenge-category`,
        method: "POST",
        body: payload,
        headers: {
          "Content-Type": "application/json",
        },
      }),
    }),
    runChallengeCode: builder.mutation<RunUserCodeResponse, QuizRunPayload>({
      query: (payload) => ({
        url: "challenge-submission/challenge-run",
        method: "POST",
        body: payload,
        headers: {
          "Content-Type": "application/json",
        },
      }),
    }),
    submitChallengeAnswer: builder.mutation<
      { response: CodeResultResponse },
      RunUserCodeRequest
    >({
      query: (payload) => ({
        url: "challenge-submission/challenge-submit",
        method: "POST",
        body: payload,
        headers: {
          "Content-Type": "application/json",
        },
      }),
    }),
  }),
});

export const {
  useGetCategoryQuery,
  useLazyGetCategoryQuery,
  useAddCategoryMutation,
  useRunChallengeCodeMutation,
  useSubmitChallengeAnswerMutation,
} = CategoryApiSlice;
